import { render, staticRenderFns } from "./PartnerConnectedDetail.vue?vue&type=template&id=52e75a82&scoped=true"
import script from "./PartnerConnectedDetail.vue?vue&type=script&lang=js"
export * from "./PartnerConnectedDetail.vue?vue&type=script&lang=js"
import style0 from "./PartnerConnectedDetail.vue?vue&type=style&index=0&id=52e75a82&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e75a82",
  null
  
)

export default component.exports